import { CommonModule } from "@angular/common";
import {
  Directive,
  EventEmitter,
  HostBinding,
  Input,
  NgModule,
  OnChanges,
  Output,
} from "@angular/core";
import { getStateIcons } from "../helpers/util";

@Directive({ selector: "[appPlannerIndicator]", standalone: true })
export class PlannerIndicatorDirective implements OnChanges {
  @Input("appPlannerIndicator") appPlannerIndicator = 0;
  @Output() clickplanner = new EventEmitter<any>();

  @HostBinding("style.width")
  width = "30px";

  @HostBinding("style.height")
  height = "30px";

  @HostBinding("attr.src")
  iconUrl: string;

  stateIcons = getStateIcons();

  ngOnChanges() {
    this.iconUrl = this.stateIcons[this.appPlannerIndicator]
      ? this.stateIcons[this.appPlannerIndicator].url
      : "";
  }
}

@NgModule({
  imports: [CommonModule, PlannerIndicatorDirective],
  // Standalone directive imported, not declared or exported
  declarations: [],
  exports: [],
})
export class PlannerIndicatorModule {}
